import { useTranslation } from "react-i18next";

import type { ClientJobSourceOverviewDto } from "../api/types";

import { Badge } from "@/components/ui/v2/badge";
import { TableColumn } from "@/types/table/tableProps";

export function useJobSourceClientsTableColumns(): TableColumn<ClientJobSourceOverviewDto>[] {
  const { t } = useTranslation();

  return [
    {
      width: "25%",
      header: t("integrations.cockpit.jobSource.clientsOverview.clientName"),
      accessor: "clientName",
      Cell: (item) => (
        <span className="font-medium">
          {item.clientName}
        </span>
      ),
    },
    {
      width: "25%",
      header: t("integrations.cockpit.jobSource.clientsOverview.clientId"),
      accessor: "clientId",
      Cell: (item) => (
        <span className="font-mono text-sm">{item.clientId}</span>
      ),
    },
    {
      width: "20%",
      header: t("integrations.cockpit.jobSource.clientsOverview.moduleStatus"),
      accessor: "moduleStatus",
      Cell: (item) => (
        <Badge
          variant={item.moduleStatus ? "success" : "neutral"}
          size="small"
        >
          {item.moduleStatus
            ? t("common.active")
            : t("common.inactive")}
        </Badge>
      ),
    },
    {
      width: "10%",
      header: t("integrations.cockpit.jobSource.clientsOverview.jobCount"),
      accessor: "jobCount",
      Cell: (item) => (
        <span className="text-right">{item.jobCount}</span>
      ),
    },
  ];
}
